import { render, staticRenderFns } from "./LifeChat.vue?vue&type=template&id=4aecb9ca&scoped=true"
import script from "./LifeChat.vue?vue&type=script&lang=js"
export * from "./LifeChat.vue?vue&type=script&lang=js"
import style0 from "./LifeChat.vue?vue&type=style&index=0&id=4aecb9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aecb9ca",
  null
  
)

export default component.exports